/**
 * 固定业务接口路径集中配置。
 *
 * 这里只维护接口 path，不维护域名；域名仍由 `domainPresets.ts` 和 `BaseWebUrl` 负责。
 */
export const API_ENDPOINTS = {
  website: {
    /** 静默退出主站 SSO Cookie。 */
    logoutSso: '/sso/logout',
    /** 获取服务端时间戳，上传流程签名前用于校准时间。 */
    serverTime: '/api/tool',
    /** 检查发布前是否还需要补充网页标签。 */
    checkIfAddTag: '/interapi/tool/v1/tag/check_if_add_tag',
    /** 获取发布工具网页侧配置数据。 */
    publishToolData: '/api/tool',
  },
  passport: {
    /** 获取 Passport 用户头像。 */
    avatar: '/user/avatar',
    /** 打开 Passport OAuth 授权页。 */
    oauthAuthorize: '/user/tool_auth.shtml',
    /** 静默退出 Passport SSO Cookie。 */
    logoutSso: '/sso/logout',
  },
  cg: {
    /** 退出 CG 侧 session。 */
    logout: '/interapi/sso/v2/user/logout_login',
    /** 用 OAuth 授权码换取工具 session_id。 */
    exchangeSession: '/interapi/sso/v2/oauth/exchange_session.json',
    /** 获取 OSS 临时凭证。 */
    ossCredential: '/interapi/oss/v1/auth/get_web_tool_private_oss_temp_auth',
    /** 获取发布版本号。 */
    getGameVersion: '/pkg/game/get_game_version',
    /** 获取发布用 gindex / pkgquery 信息。 */
    getPkgQuery: '/interapi/project/v2/pkgquery/get_pkgquery',
    /** 检查当前账号是否有作品发布权限。 */
    checkProjectAuth: '/pkg/game/check_proj_auth',
    /** 检查发布文本敏感词。 */
    checkBlackWords: '/pkg/game/check_black_words_tool',
    /** 最终发布并生成作品访问路径。 */
    getGamePath: '/pkg/game/get_game_path',
    /** 获取发布作品封面图上传签名。 */
    uploadPicSign: '/pkg/upload_image/upload_pic_sign',
    /** 发布成功后上报发布结果与作品统计信息。 */
    getGameResult: '/pkg/game/get_result',
    /** 确认上传文件签名与 MD5。 */
    getPutSign: '/interapi/project/v2/putsign/get_putsign',
    /** 写入发布版本更新说明。 */
    addUpdateLog: '/pkg/game/add_update_log',
    /** 提交作品标签属性。 */
    addGameAttr: '/interapi/tag/v1/game/add_game_attr',
    /** 获取已发布工程文件的签名下载地址。 */
    publishedProjectFileSign: '/interapi/project/v3/download/get_project_file',
    /** 获取当前账号已发布作品分页列表。 */
    publishedCyGameList: '/interapi/cy/v1/game/published_cy_game_list',
    /** 获取已发布作品版本分页列表。 */
    publishedCyGameVersionList: '/interapi/cy/v1/game/cy_game_version_list',
    /** 上报新建工程埋点。 */
    recordCreateTracking: '/interapi/report/v1/track/record_tracking_location',
    /** 提交网页标签页选择结果。 */
    submitGameTags: '/interapi/tag/v1/game/add_game_tag',
  },
  cgApi: {
    /** 刷新/校验 session_id。 */
    refreshSession: '/o_fast_login.php',
    /** 新建云端工程元信息。 */
    createProject: '/o_proj_create.php',
    /** 修改作品名。 */
    modifyProject: '/o_proj_modify.php',
  },
  upload: {
    /** 初始化项目文件上传任务，获取上传地址和参数。 */
    initUpload: '/interapi/project/v3/upload/initUpload',
    /** 上传前校验文件 MD5 和任务参数。 */
    preCheck: '/interapi/project/v3/upload/preCheck',
    /** 查询上传队列处理状态。 */
    getQueueInfo: '/interapi/project/v3/upload/getQueueInfo',
  },
  materialCg: {
    /** 获取素材库一级分类。 */
    topCategories: '/tool/goods_category/get_top_category_list',
    /** 获取素材库子分类。 */
    childCategories: '/tool/goods_category/get_child_category_list',
    /** 按分类获取素材商品列表。 */
    goodsByCategory: '/tool/goods_belongto_category/get_goodsinfo_by_categoryid',
    /** 按商品 ID 批量获取素材商品信息（收藏列表回填）。 */
    goodsBaseInfoList: '/tool/goods_baseinfo/get_baseinfo_list',
    /** 获取素材搜索结果数量。 */
    searchCount: '/tool/goods_search/get_search_count',
    /** 获取素材搜索结果列表。 */
    searchList: '/tool/goods_search/get_search_list',
  },
  materialCgApi: {
    /** 获取素材商品实际资源文件列表。 */
    goodsResource: '/oapi_goods_resource.php',
    /** 读取或切换素材收藏状态。 */
    goodsCollect: '/oapi_goods_collect.php',
  },
} as const
